/**
 * Generic HTTP request interface used by AuthProvider implementers.
 */
class HttpRequest {
  constructor() {
    this.headers = {};
    this.params = {};
    this.method = 'post';
    this.url = null;
  }
}

module.exports = HttpRequest;
